/* eslint-disable no-console */

/**
 * Minimal logger wrapper so production code stays lint-clean (`no-console`),
 * while still allowing us to emit diagnostics when needed.
 */
export const logger = {
  debug: (...args: unknown[]) => {
    if (process.env.NODE_ENV !== 'production') console.log(...args);
  },
  info: (...args: unknown[]) => {
    console.log(...args);
  },
  warn: (...args: unknown[]) => {
    console.warn(...args);
  },
  error: (...args: unknown[]) => {
    console.error(...args);
  }
};


